/* ============================================================
   pd-lookbook.js — PD Lookbook 板块交互
   - 加购：复用现有 window.v3OpenQuickAdd（定义于 v3-homepage.js），
           本文件只负责触发 + 手机端给 #v3-qa-modal 打/摘 .v3-qa--sheet 类。
   - 展示：桌面手风琴、热点圆点高亮、手机轮播 pager。
   - 不引入任何 .v3-reveal / .v3-visible 渐显动画。
   - assets/v3-homepage.js 一行不动。
   ============================================================ */
(function () {
  'use strict';

  /* 资源可能被多个 section 实例各引入一次 —— 全局只初始化一次。 */
  if (window.__pdlbLoaded) return;
  window.__pdlbLoaded = true;

  var SHEET = 'v3-qa--sheet';
  function isMobile() { return window.matchMedia('(max-width:768px)').matches; }
  function modal() { return document.getElementById('v3-qa-modal'); }

  /* ----------------------------------------------------------
     手机端底部 sheet：打类 / 摘类（handoff §4 锁定版）
     - 关闭信号 = #v3-qa-modal 的 hidden 属性（closeModal/加购成功都设 hidden）。
     - 弹窗是单例（getModal 复用同一节点），observer 挂一次即可。
     - 只过滤 hidden 属性变化，加类那一下不会误触发摘类。
  ---------------------------------------------------------- */
  var watching = false;
  function watchClose(m) {
    if (watching) return;
    watching = true;
    new MutationObserver(function () {
      if (m.classList.contains(SHEET) && m.hasAttribute('hidden')) {
        m.classList.remove(SHEET);
      }
    }).observe(m, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* ----------------------------------------------------------
     加购触发：固定走 .pdlb-add（绝不用 .v3-pc__quick-add）
     —— 全站委托在捕获阶段匹配 .v3-pc__quick-add 并 stopPropagation()，
        若按钮带了它，这里的打类逻辑就跑不到、手机 sheet 失效。
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdlb-add');
    if (!btn || btn.hasAttribute('disabled')) return;

    var card = btn.closest('.v3-pc'); // 卡片须带 .v3-pc + 内嵌 .v3-pc__meta
    var handle = btn.getAttribute('data-product-handle') ||
                 (card && card.getAttribute('data-product-handle'));
    if (!handle || typeof window.v3OpenQuickAdd !== 'function') return;

    e.preventDefault();
    window.v3OpenQuickAdd(handle, card, btn); // 签名：(handle, card, triggerBtn)

    if (isMobile()) {
      var m = modal();
      if (m) { watchClose(m); m.classList.add(SHEET); }
    }
  });

  /* ----------------------------------------------------------
     热点圆点 → 对应产品卡黄框高亮 + 横滑到可视区
     capture 阶段运行，先于 look__img 的手风琴展开处理。
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.pdlb-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();

    var look = dot.closest('.pdlb-look');
    if (!look) return;
    var idx = dot.getAttribute('data-idx');

    look.querySelectorAll('.pdlb-card').forEach(function (c) {
      c.classList.remove('is-active');
    });
    var card = look.querySelector('.pdlb-card[data-idx="' + idx + '"]');
    if (card) {
      card.classList.add('is-active');
      card.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }, true);

  /* ----------------------------------------------------------
     每个 section 实例的初始化：手风琴 + 手机 pager
  ---------------------------------------------------------- */
  function initSection(section) {
    if (!section || section.__pdlbInit) return;
    section.__pdlbInit = true;

    var track = section.querySelector('.pdlb-track');
    if (!track) return;
    var looks = track.querySelectorAll('.pdlb-look');

    /* ── 产品卡片左右箭头（仅电脑端可见；手机端 CSS 隐藏，纯靠滑动）──
       到两端时用 hidden 属性收起对应箭头；卡片溢出时才出现。 */
    section.querySelectorAll('.pdlb-cards-wrap').forEach(function (wrap) {
      var scroller = wrap.querySelector('.pdlb-cards');
      if (!scroller) return;
      var prev = wrap.querySelector('.pdlb-cards-nav--prev');
      var next = wrap.querySelector('.pdlb-cards-nav--next');

      function step() {
        var c = scroller.querySelector('.pdlb-card');
        return (c ? c.getBoundingClientRect().width : 160) + 10; // 卡宽 + gap
      }
      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth - 1;
        var overflow = max > 0;
        if (prev) prev.hidden = !overflow || scroller.scrollLeft <= 0;
        if (next) next.hidden = !overflow || scroller.scrollLeft >= max;
      }
      wrap.__pdlbUpdate = update;

      if (prev) prev.addEventListener('click', function () {
        scroller.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        scroller.scrollBy({ left: step(), behavior: 'smooth' });
      });
      scroller.addEventListener('scroll', update, { passive: true });
      update();
      setTimeout(update, 350); // 图片晚加载会改变尺寸，补刷一次
    });

    function refreshArrows(scope) {
      (scope || section).querySelectorAll('.pdlb-cards-wrap').forEach(function (w) {
        if (w.__pdlbUpdate) w.__pdlbUpdate();
      });
    }
    window.addEventListener('resize', function () { refreshArrows(); });

    /* 桌面手风琴：点 look 图展开该 look、收起其余（手机端不跑） */
    looks.forEach(function (L) {
      var img = L.querySelector('.pdlb-look__img');
      if (!img) return;
      img.addEventListener('click', function (e) {
        if (isMobile()) return;
        if (e.target.closest('.pdlb-dot')) return;
        if (L.classList.contains('is-open')) return;
        looks.forEach(function (x) { x.classList.remove('is-open'); });
        L.classList.add('is-open');
        // 展开动画结束后卡片真实宽度才确定，刷新该 look 的箭头显隐
        setTimeout(function () { refreshArrows(L); }, 480);
      });
    });
  }

  function init() {
    document.querySelectorAll('.pdlb-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* 主题编辑器里加/改 section 时重新初始化 */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = (root.classList && root.classList.contains('pdlb-section'))
        ? root
        : root.querySelector('.pdlb-section');
      if (s) initSection(s);
    });
  }
})();
